/* El isologo real del manual de marca, tal como lo sirve `apps/web` desde
 * `public/marca/` (recortado de `assets/isologo-gradient.png`, 219×256). Es la
 * única marca gráfica de Klavia: no se redibuja, no se recolorea y no se
 * reemplaza por un cuadrado, una casita ni una inicial. Quien lo pinta lo hace
 * con un `<img>` a esta ruta; el middleware la sirve siempre, sin sesión. */
export const ISOLOGO_SRC = "/marca/isologo.png";

/** Ancho ÷ alto del PNG, para fijar `width`/`height` donde no hay CSS (correos). */
export const ISOLOGO_PROPORCION = 219 / 256;
